import { Alert, AutoComplete, Input, Space } from 'antd';
import type { AddressAutocompleteSelection } from '~/app/hooks/site/useSiteAddressAutocomplete';
import { useSiteAddressAutocomplete } from '~/app/hooks/site/useSiteAddressAutocomplete';

type Props = {
  value?: string;
  placeholder: string;
  noResultsText: string;
  loadingText: string;
  missingKeyText: string;
  loadFailedText: string;
  onChange: (value: string) => void;
  onSelect: (selection: AddressAutocompleteSelection) => Promise<void>;
};

export function SiteAddressAutocomplete({
  value,
  placeholder,
  noResultsText,
  loadingText,
  missingKeyText,
  loadFailedText,
  onChange,
  onSelect,
}: Props) {
  const { errorMessage, handleSelect, isLoading, options } =
    useSiteAddressAutocomplete({
      searchValue: value ?? '',
      missingKeyText,
      loadFailedText,
      onAddressSelect: onSelect,
    });

  return (
    <Space direction="vertical" size={8} style={{ width: '100%' }}>
      <AutoComplete
        value={value}
        options={options}
        notFoundContent={isLoading ? loadingText : noResultsText}
        onChange={onChange}
        onSelect={handleSelect}
      >
        <Input placeholder={placeholder} />
      </AutoComplete>

      {errorMessage ? (
        <Alert type="warning" showIcon title={errorMessage} />
      ) : null}
    </Space>
  );
}
